interface MetaCardProps {
    title: string;
    action?: React.ReactNode;
    /** False when a child owns its own padding (e.g. a list of rows) - the header strip still gets the standard padding either way. */
    pad?: boolean;
    /** False while a child renders an absolutely-positioned overflow menu. */
    clip?: boolean;
    children: React.ReactNode;
}

// Small labelled card for the communication form/detail meta rail. Kept
// local rather than reused from patient-files/overview's Card.
export function MetaCard({ title, action, pad = true, clip = true, children }: MetaCardProps) {
    return (
        <div
            // shrink-0: the rails are height-capped flex columns - without it,
            // short viewports compress the cards instead of scrolling the rail.
            className={`shrink-0 bg-white border border-gray-200 rounded-xl shadow-[0px_1px_2px_rgba(0,0,0,0.04)] ${
                clip ? 'overflow-hidden' : ''
            }`}
        >
            <div className="h-10 px-4 border-b border-gray-100 flex items-center gap-2">
                <h3 className="text-[11px] font-bold text-gray-500 uppercase tracking-[0.06em]">
                    {title}
                </h3>
                {action && <span className="ml-auto">{action}</span>}
            </div>
            {pad ? <div className="px-4 py-3.5 flex flex-col gap-3">{children}</div> : children}
        </div>
    );
}
